import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function authServiceReducer(state = initialState.responseTest, action) {
    switch (action.type) {
        case types.GET_SUCCESSFULL: return {
            get: action.getResponse,
            post: state.post
        };

        case types.POST_SUCCESSFULL: return {
            get: state.get,
            post: action.postResponse
        };

        default : return state; 
    }   
}